import { DELETE, GET, POST, PUT } from './api';

const table = 'financing-desk-controls';

export const Create = async (params) => {
  return await POST(`/${table}`, params, true);
};

export const Read = async (filters = '') => {
  const populate = [
    'conhecimento_compra_midia',
    'entrega_midia',
    'parecer_acesso_midia',
    'instalacao_midia',
    'protocolo_acesso_midia',
    'conexao_midia',
    'primeiro_pagamento_midia',
    'primeira_fatura_midia',
    'proposta_financeira.informacoes_projeto',
    'proposta_financeira.informacoes_cliente',
    'proposta_financeira.informacoes_profissionais',
    'proposta_financeira.endereco_residencial',
    'proposta_financeira.endereco_instalacao',
    'proposta_financeira.endereco_correspondencia',
    'proposta_financeira.pdf_recomenda_faturamento',
    'proposta_financeira.cliente',
    'proposta_financeira.pdf_ciencia_compra',
    'proposta_financeira.contrato_financiamento',
    'proposta_financeira.pdf_carta_credito',
    'proposta_financeira.propostas_banco.banco',
    'proposta_financeira.integrador',
    'proposta_financeira.nf_venda',
    'proposta_financeira.nf_compra',
    'proposta_financeira.contrato_financiamento',
    'proposta_financeira.informacoes_empresa',
    'proposta_financeira.informacoes_socio',
    'proposta_financeira.informacoes_empresa',
    'proposta_financeira.espelho_pdf',
  ]
    .map((m, k) => `populate[${k}]=${m}`)
    ?.join('&');
  return await GET(
    `/${table}${filters}${filters?.length ? `&` : `?`}${populate}`,
    true
  );
};

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
};

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
};

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
};
